import { startRegistration, startAuthentication, browserSupportsWebAuthn, platformAuthenticatorIsAvailable } from '@simplewebauthn/browser';
import api from '../api';

const chave = (userId) => `rfc_biometria_${userId}`;

export const suportaBiometria = () => {
  try {
    return browserSupportsWebAuthn();
  } catch (e) {
    return false;
  }
};

// true quando o aparelho tem Face ID / Touch ID / digital disponível.
export async function biometriaDisponivel() {
  if (!suportaBiometria()) return false;
  try {
    return await platformAuthenticatorIsAvailable();
  } catch (e) {
    return false;
  }
}

// Situação da biometria para este usuário neste aparelho: 'ativa' | 'recusada' | null
export function situacaoLocal(userId) {
  try {
    const salvo = JSON.parse(localStorage.getItem(chave(userId)) || 'null');
    if (!salvo) return null;
    // "Agora não" volta a perguntar depois de 30 dias
    if (salvo.estado === 'recusada' && Date.now() - salvo.em > 30 * 24 * 3600 * 1000) return null;
    return salvo.estado;
  } catch (e) {
    return null;
  }
}

export function marcarLocal(userId, estado) {
  localStorage.setItem(chave(userId), JSON.stringify({ estado, em: Date.now() }));
}

const mensagem = (error, padrao) => {
  if (error && error.name === 'NotAllowedError') return 'Operação cancelada.';
  if (error && error.name === 'InvalidStateError') return 'A biometria deste aparelho já está cadastrada.';
  return error?.response?.data?.error || error?.response?.data?.erro || padrao;
};

// Cadastra a biometria deste aparelho para o usuário logado.
export async function cadastrarBiometria(userId) {
  try {
    const { data: options } = await api.post('webauthn/registro/opcoes');
    const response = await startRegistration(options);
    await api.post('webauthn/registro/verificar', { response });
    marcarLocal(userId, 'ativa');
    return { ok: true };
  } catch (error) {
    if (error && error.name === 'InvalidStateError') marcarLocal(userId, 'ativa');
    return { ok: false, message: mensagem(error, 'Não foi possível ativar a biometria.') };
  }
}

// Pede a biometria do usuário logado para confirmar uma ação sensível (ex.: fechar a pelada).
// Sem biometria ativa neste aparelho, segue sem ela: { ok: true, biometria: null }.
export async function confirmarComBiometria(userId) {
  if (situacaoLocal(userId) !== 'ativa' || !suportaBiometria()) return { ok: true, biometria: null };
  try {
    const { data } = await api.post('webauthn/confirmacao/opcoes');
    if (!data.disponivel) return { ok: true, biometria: null };
    const response = await startAuthentication(data.options);
    return { ok: true, biometria: { desafioId: data.desafioId, response } };
  } catch (error) {
    return { ok: false, message: mensagem(error, 'Não foi possível confirmar com biometria.') };
  }
}

// Login com a biometria do aparelho. Retorna a mesma resposta de /sessions.
export async function entrarComBiometria() {
  try {
    const { data } = await api.post('webauthn/login/opcoes');
    const response = await startAuthentication(data.options);
    const { data: sessao } = await api.post('webauthn/login/verificar', { desafioId: data.desafioId, response });
    return { ok: true, sessao };
  } catch (error) {
    return { ok: false, message: mensagem(error, 'Não foi possível entrar com biometria.') };
  }
}
